import { Card, Form } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ActionButton from "../../../../../common/components/buttons/ActionButton";
import { OrderDirection } from "../../../../../common/enums";
import { Permission } from "../../../../../common/security/enums";
import ComponentWithPermission from "../../../../auth/components/ComponentWithPermission";
import { ContractOrderByColumn, ContractView } from "../../../enums";
import { ContractFilterPageRequest } from "../../../types";
import { ContractFilterForm } from "../../forms/ContractFilterForm";
import { RecalculatePredictedCommissionsModalForm } from "../../forms/RecalculatePredictedCommissionsModalForm";

type Props = {
  validatedSearchParams?: ContractFilterPageRequest;
  updateSearchParams: (searchParams: ContractFilterPageRequest, append?: boolean, replace?: boolean) => void;
};

export const ContractPredictedCommissionsListFilterView = ({ validatedSearchParams, updateSearchParams }: Props) => {
  const { t } = useTranslation();

  const [form] = Form.useForm<ContractFilterPageRequest>();
  const [recalculatePredictedCommissionsModalOpen, setRecalculatePredictedCommissionsModalOpen] = useState(false);

  const handleFilterClear = () => {
    form.resetFields();
    updateSearchParams(form.getFieldsValue(), false, true);
  };

  return (
    <>
      <Card
        className="card-box"
        title={<h2>{t("contract.titles.list")}</h2>}
        extra={
          <>
            <ComponentWithPermission permissions={[Permission.COMMISSIONS_MANAGE]}>
              <ActionButton
                icon="euro"
                color="orange"
                variant="outlined"
                size="middle"
                onClick={() => setRecalculatePredictedCommissionsModalOpen(true)}
              >
                {t("contract.actions.recalculatePredictedCommissions")}
              </ActionButton>
            </ComponentWithPermission>

            <ActionButton color="danger" size="middle" variant="outlined" icon="reload" onClick={handleFilterClear}>
              {t("common.resetFilter")}
            </ActionButton>
          </>
        }
      >
        <ContractFilterForm
          form={form}
          report={ContractView.INTERNAL_PREDICTED_COMMISSIONS_REPORT}
          orderBy={[ContractOrderByColumn.CREATED_AT]}
          orderDirections={[OrderDirection.DESC]}
          updateSearchParams={updateSearchParams}
          validatedSearchParams={validatedSearchParams}
        />
      </Card>

      <RecalculatePredictedCommissionsModalForm
        open={recalculatePredictedCommissionsModalOpen}
        onFormCancel={() => setRecalculatePredictedCommissionsModalOpen(false)}
      />
    </>
  );
};
